
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.45 1.164c.299-.921 1.602-.921 1.901 0l.565 1.737a1 1 0 00.95.691h1.827c.97 0 1.372 1.24.588 1.81L8.804 6.474a1 1 0 00-.364 1.118l.565 1.737c.299.921-.755 1.688-1.54 1.118L5.989 9.375a1 1 0 00-1.175 0l-1.478 1.073c-.784.57-1.838-.197-1.539-1.118l.565-1.737a1 1 0 00-.364-1.118L.52 5.401c-.784-.569-.381-1.809.587-1.809h1.827a1 1 0 00.95-.69l.565-1.738z","fill":"#EDC843"}})])
          )
        }
      }
    